import React, { useState } from 'react';
import { Steps, ConfigProvider } from 'antd';
import { 
  UserOutlined, 
  BankOutlined, 
  SafetyOutlined,
  CheckCircleOutlined,
  RocketOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';

import IntroductionStep from './steps/IntroductionStep';
import MemberRegistrationStep from './steps/MemberRegistrationStep';
import MemberRegistrationProgress from './steps/MemberRegistrationProgress';
import LedgerRegistrationStep from './steps/LedgerRegistrationStep';
import CardBindingStep from './steps/CardBindingStep';

import CompletionStep from './steps/CompletionStep';
import './AccountOpen.css';

const AccountOpen: React.FC = () => {
  const [current, setCurrent] = useState(0);


  const steps = [
    {
      title: '开户引导',
      icon: <RocketOutlined />,
      description: '了解开户流程'
    },
    {
      title: '会员开立',
      icon: <UserOutlined />,
      description: '填写企业基本信息'
    },
    {
      title: '进度审核',
      icon: <ClockCircleOutlined />,
      description: '会员开立结果审核'
    },
    {
      title: '登记簿开立',
      icon: <SafetyOutlined />,
      description: '二维码授权验证'
    },
    {
      title: '银行卡绑定',
      icon: <BankOutlined />,
      description: '绑定企业银行卡'
    },

    {
      title: '开立完成',
      icon: <CheckCircleOutlined />,
      description: '账户开立成功'
    }
  ];

  const next = () => {
    setCurrent(c => c + 1);
  };

  const prev = () => {
    setCurrent(c => c - 1);
  };

  const renderStepContent = () => {
    switch (current) {
      case 0:
        return <IntroductionStep current={current} onNext={next} onPrev={prev} />;
      case 1:
        return <MemberRegistrationStep current={current} onNext={next} onPrev={prev} />;
      case 2:
        return <MemberRegistrationProgress current={current} onNext={next} onPrev={prev} />;
      case 3:
        return <LedgerRegistrationStep current={current} onNext={next} onPrev={prev} onReopen={() => setCurrent(0)} />;
      case 4:
        return <CardBindingStep current={current} onNext={next} onPrev={prev} />;
      case 5:
        return <CompletionStep />;
      default:
        return null;
    }
  };

  const visibleSteps = steps.filter(step => step.title !== '进度审核');

  const getStepCurrent = () => {
    if (current === 0) return -1; // 引导页不显示步骤
    if (current === 1 || current === 2) return 0; // 会员开立和进度审核都对应第一个可见步骤
    if (current === 3) return 1; // 登记簿开立对应第二个可见步骤
    if (current === 4) return 2; // 银行卡绑定对应第三个可见步骤
    if (current === 5) return 3; // 开立完成对应第四个可见步骤
    return -1;
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <div className="enterprise-registration-container" style={{ minHeight: '100vh', background: '#f5f7fa' }}>
        {/* 只在引导步骤显示步骤条 */}
        {current > 0 && (
          <div className="registration-content" style={{ maxWidth: '800px', margin: '0 auto', padding: '24px 24px 0 24px' }}>
            <div className="enterprise-steps">
              <Steps
                current={getStepCurrent()}
                items={visibleSteps.slice(1)} // 去掉引导步骤
              />
            </div>
          </div>
        )}
        
        <div className="enterprise-slide-up" style={{ marginTop: current > 0 ? 0 : 24 }}>
          {renderStepContent()}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default AccountOpen;